var styleDataHash = "0b93d0dc";
const injectCss = (() => {
  var css = `.YRFDQ{margin-left:0;margin-right:auto;z-index:1}.YRFDQ:not(.MmnB1){float:left;margin-right:40px}@supports not (contain:inline-size){@media only screen and (max-width:480px){.YRFDQ:not(.MmnB1){float:none;margin-right:auto}}}@container (width < 480px){.YRFDQ:not(.MmnB1){float:none;margin-right:auto}}.adQKh{margin-left:auto;margin-right:0;z-index:1}.adQKh:not(.MmnB1){float:right;margin-left:40px}@supports not (contain:inline-size){@media only screen and (max-width:480px){.adQKh:not(.MmnB1){float:none;margin-left:auto}}}@container (width < 480px){.adQKh:not(.MmnB1){float:none;margin-left:auto}}.JP-Xf{clear:both;display:block}.JP-Xf:not(.GReBi){margin-left:auto;margin-right:auto;max-width:100%}.GReBi,.MmnB1{width:100%}._8lQyx .GReBi,._8lQyx .MmnB1{margin:0 -8px;width:auto}.LRSFx{width:fit-content}._0IHZk{margin-left:auto;margin-right:auto;max-width:100%}.C7ZPy{width:min(350px,100%)!important}._8lQyx .C7ZPy{width:50%}.IWQbE{margin-left:auto;margin-right:auto}._8lQyx .IWQbE{width:150px}.Dpunj{display:flex}`;
  var isTest = typeof process !== "undefined" && process.env && false;
  if (isTest || !css || typeof document === "undefined") {
    return;
  }
  if (document.querySelector('style[data-ricos-style-hash="' + styleDataHash + '"]')) {
    return;
  }
  var head = document.head || document.getElementsByTagName("head")[0];
  var style = document.createElement("style");
  style.setAttribute("data-ricos-style-hash", styleDataHash);
  style.type = "text/css";
  head.appendChild(style);
  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
});
injectCss();
var general_default = {
  "alignLeft": "YRFDQ",
  "textWrapNowrap": "MmnB1",
  "alignRight": "adQKh",
  "alignCenter": "JP-Xf",
  "sizeFullWidth": "GReBi",
  "renderedInTable": "_8lQyx",
  "sizeOriginal": "LRSFx",
  "sizeContent": "_0IHZk",
  "sizeSmall": "C7ZPy",
  "sizeSmallCenter": "IWQbE",
  "flex": "Dpunj"
};
export {
  general_default as default,
  injectCss
};
//# sourceMappingURL=general-scss.js.map
